import React from 'react'
import PropTypes from 'prop-types'

import { onEnterOrSpace } from '../../../utils/key-handler'

import './Radio.css'

const radioStyles = Object.freeze({
  DEFAULT: 'default',
  TAB: 'tab',
  CHUNKY: 'chunky'
})

const getStyle = style => Object.values(radioStyles).indexOf(style) !== -1
  ? style
  : radioStyles.DEFAULT

const Radio = ({ field, id, value, label, form, disabled, style = radioStyles.DEFAULT, onSelect, ...props }) => (
  <div data-testid='radio-input-container' styleName={`${getStyle(style)}InputGroup`} className={getStyle(style)}>
    <input
      data-testid='radio-input-control'
      styleName={`${getStyle(style)}Radio`}
      name={field.name}
      id={id}
      type='radio'
      value={value}
      checked={field.value === value}
      onClick={onSelect}
      onChange={(...a) => {
        if (onSelect) {
          onSelect()
          return
        }
        form.setFieldTouched(field.name, true)
        field.onChange(...a)
      }}
      onBlur={field.onBlur}
      disabled={disabled}
      {...props}
    />
    <label data-testid='radio-label' styleName={`${getStyle(style)}Label`} htmlFor={id} tabIndex='0' onKeyDown={onEnterOrSpace(() => {
      if (!disabled) {
        if (onSelect) {
          onSelect()
          return
        }
        form.setFieldValue(field.name, value)
      }
    })}>
      {label}
    </label>
  </div>
)

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
})

Radio.propTypes = {
  field: FieldShape.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
  style: PropTypes.string,
  onSelect: PropTypes.func
}

export default Radio
export { radioStyles }
